import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const TestResultPage = () => {
  const { state } = useLocation();
  if (!state) return <div>No Result Data</div>;
  const { result, quiz, userAnswers = {} } = state;
// TotalMarks is a computed alias only in the quiz-list query.
// The start-test endpoint returns raw DB rows where it's null,
// so derive it from the raw columns instead.
const totalMarks = quiz.TotalMarks ?? ((quiz.maxNOQ || quiz.MaxNOQ || 0) * (quiz.positiveMarks || 1));
const percentage = totalMarks > 0
  ? Math.round((result.totalMarks / totalMarks) * 100)
  : 0;
const skippedCount = (quiz.maxNOQ || quiz.MaxNOQ || 0) - result.attemptedCount;

  return (
    <div className="min-h-screen mt-20 bg-[#1a0b2e] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden">

        {/* Header */}
        <div className="bg-gradient-to-r from-green-500 to-teal-600 p-8 text-white text-center">
          <div className="text-5xl mb-3">
            {percentage >= 70 ? '🏆' : percentage >= 40 ? '📊' : '📝'}
          </div>
          <h1 className="text-3xl font-bold mb-2">Test Completed!</h1>
          <p className="opacity-90">{quiz.title}</p>
          {quiz.QuizCode && (
            <p className="text-sm opacity-70 mt-1">{quiz.QuizCode}</p>
          )}
        </div>

        <div className="p-6 sm:p-8">
          {/* Score */}
          <div className="text-center mb-8">
            <span className="text-gray-500 uppercase tracking-widest text-xs font-bold">Your Score</span>
            <div className="text-6xl font-bold text-[#2d1b4e] my-2">
              {result.totalMarks}
              <span className="text-2xl text-gray-400"> / {totalMarks}</span>
            </div>
            <div className="inline-block px-4 py-1 rounded-full text-sm font-semibold mt-1"
              style={{
                background: percentage >= 70 ? '#d1fae5' : percentage >= 40 ? '#fef3c7' : '#fee2e2',
                color:      percentage >= 70 ? '#065f46' : percentage >= 40 ? '#92400e' : '#991b1b',
              }}
            >
              {percentage}% — {percentage >= 70 ? 'Excellent' : percentage >= 40 ? 'Good effort' : 'Keep practising'}
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8 text-center">
            <div className="p-4 bg-green-50 rounded-xl border border-green-100">
              <div className="text-2xl font-bold text-green-600">{result.correctCount}</div>
              <div className="text-xs text-gray-500 mt-1">Correct</div>
            </div>
            <div className="p-4 bg-red-50 rounded-xl border border-red-100">
              <div className="text-2xl font-bold text-red-600">{result.wrongCount}</div>
              <div className="text-xs text-gray-500 mt-1">Wrong</div>
            </div>
            <div className="p-4 bg-blue-50 rounded-xl border border-blue-100">
              <div className="text-2xl font-bold text-blue-600">{result.attemptedCount}</div>
              <div className="text-xs text-gray-500 mt-1">Attempted</div>
            </div>
            <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
              <div className="text-2xl font-bold text-gray-500">{skippedCount}</div>
              <div className="text-xs text-gray-500 mt-1">Skipped</div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/test-review"
              state={{ quiz, userAnswers }}
              className="flex-1 bg-[#2d1b4e] text-white py-3 rounded-xl font-bold text-center hover:bg-purple-900 transition-colors flex items-center justify-center gap-2"
            >
              📋 Review Submission
            </Link>
            <Link
              to="/test-zone"
              className="flex-1 bg-gray-100 text-gray-700 py-3 rounded-xl font-bold text-center hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"
            >
              ← Back to Test Zone
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestResultPage;